/* eslint-disable */
import React, { useState, useEffect } from "react";
import Notification from "../../components/notification";
import { Button, FloatingLabel } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { ApiEndpoint, ShortUrlEndpoint } from "../../utils/ApiEndpoint";
import { useAuth } from "../../Context/AuthContext";
import { httpClient } from "../../utils/HttpClient";
import PropTypes from "prop-types";
import { useGetHostLinks } from '../../features/shortlinks/hooks/useGetHostLinks';
const NewShortLink = ({ handleClose }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  //   const [token, setToken] = useState("");
  const [notificationType, setNotificationType] = useState("");
  const [selectedHost, setSelectedHost] = useState("");
  const [messageNotification, setMessageNotification] =
    useState("Url Corta Creada");
  const [values, setValues] = useState({
    displayname: "",
    longurl: "",
  });

  const { data: hostsList } = useGetHostLinks();


  // function GetToken() {
  //   httpClient(
  //     "GET",
  //     ApiEndpoint + "partnersettings/" + userData.uid_partner,
  //     {},
  //     userData.token
  //   ).then((response) => {
  //     setToken(response.data.tokenbitly);
  //   });
  // }


  // function GenerateLink() {
  //   const config = {
  //     headers: {
  //       Authorization: "Bearer " + token,
  //       "Content-Type": "application/json",
  //     },
  //   };
  //   axios
  //     .post(
  //       "https://api-ssl.bitly.com/v4/shorten",
  //       {
  //         long_url: values.longurl,
  //         // group_guid: userData.uid_partner,
  //       },
  //       config
  //     )
  //     .then(function (response) {
  //       var responseLink = response.data;
  //       console.log(responseLink);
  //       let URIShort = ApiEndpoint + "campaigns/createShortLink";
  //       var userData = Auth.getSessionData();

  //       axios
  //         .post(URIShort, {
  //           idpartner: userData.uid_partner,
  //           displayname: values.displayname,
  //           shortlinks: responseLink.link,
  //           originallink: values.longurl,
  //           bitlink: responseLink.id,
  //           responsedetail: JSON.stringify(responseLink),
  //         })
  //         .then(function (response) {
  //           if (response.data.error) {
  //             setMessageNotification("Ha ocurrido un error");
  //             setNotificationType("warning");
  //             setShow(true);
  //           } else {
  //             setMessageNotification("Campaña creada");
  //             setNotificationType("");
  //             setShow(true);
  //             handleClose();
  //           }
  //           return;
  //         })
  //         .catch(function (error) {
  //           setMessageNotification("Ha ocurrido un error");
  //           setNotificationType("warning");
  //           setShow(true);
  //           console.log(error);
  //         });
  //     })
  //     .catch(function (error) {
  //       setMessageNotification("Ha ocurrido un error");
  //       setNotificationType("warning");
  //       setShow(true);
  //       console.log(error);
  //     });
  // }

  function GenerateLinkTtr() {
    httpClient(
      "POST",
      ShortUrlEndpoint + "config/createurl",
      {
        endpoint: values.longurl,
        domain: selectedHost, //"odt.mx",
      },
      userData.token
    )
      .then(function (response) {
        var responseLink = response.data;
        console.log(responseLink);
        let URIShort = ApiEndpoint + "campaigns/createShortLink";
        var userData = Auth.getSessionData();

        httpClient(
          "POST",
          URIShort,
          {
            idpartner: userData.uid_partner,
            displayname: values.displayname,
            shortlinks: responseLink.message,
            originallink: values.longurl,
            bitlink: responseLink.code,
            responsedetail: JSON.stringify(responseLink),
          },
          userData.token
        )
          .then(function (response) {
            if (response.data.error) {
              setMessageNotification("Ha ocurrido un error");
              setNotificationType("warning");
              setShow(true);
            } else {
              setMessageNotification("Campaña creada");
              setNotificationType("");
              setShow(true);
              handleClose();
            }
            return;
          })
          .catch(function (error) {
            setMessageNotification("Ha ocurrido un error");
            setNotificationType("warning");
            setShow(true);
            console.log(error);
          });
      })
      .catch(function (error) {
        setMessageNotification("Ha ocurrido un error");
        setNotificationType("warning");
        setShow(true);
        console.log(error);
      });
  }

  const handleSubmit1 = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);

    GenerateLinkTtr();
  };
  const onChange = (event) => {
    const { name, value } = event.target;
    setValues({ ...values, [name]: value });
  };
  return (
    <>
      <div className="NewCampaignUrl">
        <Form noValidate validated={validated} onSubmit={handleSubmit1}>
          <FloatingLabel label="Host *" className="mb-3">
            <Form.Select
              id="idHost"
              name="idHost"
              onChange={(selectedOption) => {
                setSelectedHost(`${selectedOption.target.value}`);
              }}
              value={selectedHost}
              required
              aria-label="select_host"
              isInvalid={selectedHost === "Selecciona una opción"}
              isValid={selectedHost !== "Selecciona una opción"}
            >
              {!!hostsList?.length &&
                [{
                  id_shortlinks_hosts: "",
                  vc_shortlinks_host: "Selecciona una opción"
                }].concat(hostsList).map((host) => (
                  <option
                    key={host.id_shortlinks_hosts}
                    value={host.vc_shortlinks_host}
                  >
                    {host.vc_shortlinks_host}
                  </option>
                ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              Selecciona un host
            </Form.Control.Feedback>
          </FloatingLabel>
          <FloatingLabel label="Alias *" className="mb-3">
            <Form.Control
              name="displayname"
              id="displayname"
              placeholder="Escribe un nombre"
              required
              onChange={(event) => {
                onChange(event);
              }}
            />
          </FloatingLabel>
          <h5>Agrega un nombre para poder identificar esta url corta</h5>

          <FloatingLabel label="Url *" className="mb-3">
            <Form.Control
              name="longurl"
              id="longurl"
              placeholder="Escribe la Url *"
              required
              onChange={(event) => {
                onChange(event);
              }}
            />
          </FloatingLabel>
          <h5>Agrega la url que deseas acortar</h5>

          <div className="text-right">
            <Button
              variant="primary"
              type="submit"
              // onClick={() => {
              //   GenerateLink();
              // }}
              className="align-self-end"
            >
              Enviar
            </Button>
          </div>
        </Form>
      </div>

      <Notification
        alertType={notificationType}
        show={show}
        setShow={setShow}
        message={messageNotification}
      />
    </>
  );
};
NewShortLink.propTypes = {
  handleClose: PropTypes.func.isRequired,
};
export default NewShortLink;
